<div
  *ngIf="show"
  [class.has-override]="hasSomeOverride()"
  class="override-indicator"
  (click)="isOpen ? close() : open()"
></div>
<div class="override-dialog" *ngIf="isOpen">
  <div class="header">
    <div class="title">Overrides</div>
    <button class="override-btn" *ngIf="hasSomeOverride()" (click)="reset()">
      Reset All
    </button>
  </div>
  <div class="actions">
    <button (click)="close()" class="override-btn close-btn">
      <i class="fa fa-times"></i>
    </button>
  </div>

  <div class="override-control-bar">
    <div class="override-tabs">
      <button
        type="button"
        class="override-tab"
        [class.override-tab--active]="tab === 0"
        (click)="onTab(0)"
        >Environment</button
      >
      <button
        type="button"
        class="override-tab"
        [class.override-tab--active]="tab === 1"
        (click)="onTab(1)"
        >Feature Toggles</button
      >
    </div>
    <div class="override-controls">
      <ng-container *ngIf="tab === 1">
        <div class="override-control override-control--search">
          <input
            type="search"
            class="form-control override-control--search__input"
            placeholder="Search toggles..."
            size="30"
            style="width: unset"
            aria-label="Search Toggles"
            [formControl]="searchControl"
          />
          <button
            *ngIf="searchControl.value"
            type="button"
            class="close override-control--search__clear-btn"
            title="Clear Search"
            (click)="clearSearch()"
            >&times;</button
          >
        </div>
      </ng-container>
    </div>
  </div>

  <div *ngIf="tab === 0" class="override-content env-overrides">
    <div class="form-group">
      <label for="environment-chooser">Choose backend environment</label>
      <select
        id="environment-chooser"
        class="form-control"
        [(ngModel)]="envNameOverride"
        (change)="onEnvChange($event)"
      >
        <option [value]="env.key" *ngFor="let env of envs">
          {{ env.name }} {{ env.default ? '(default)' : '' }}
        </option>
      </select>
    </div>

    <div class="form-group">
      <label for="custom-url">Override url</label>
      <input
        id="custom-url"
        class="form-control"
        type="text"
        [(ngModel)]="urlOverride"
        (input)="onUrlChange($event)"
      />
    </div>
    <div class="form-group">
      <label for="custom-url-2">Override urlV2</label>
      <input
        id="custom-url-2"
        class="form-control"
        type="text"
        [(ngModel)]="urlV2Override"
        (input)="onUrlV2Change($event)"
      />
    </div>
  </div>

  <div class="override-content" *ngIf="tab === 1">
    <!-- Tenant Selection -->
    <div class="form-group">
      <label for="tenant-input">Tenant</label>
      <div class="d-flex">
        <div class="d-flex align-items-center" style="flex: 1">
          <input
            id="tenant-input"
            class="form-control w-70 mr-1"
            type="text"
            [(ngModel)]="tenantLocalToggles"
          />
          <button
            class="btn btn-outline-info ms-2"
            (click)="applyTenantFeatureFlag()"
            >Apply Tenant Feature Flag</button
          >
        </div>
        <div class="d-flex align-items-center">
          <button
            [ngClass]="{
              'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light':
                isSyncToBackendLoading,
            }"
            class="btn btn-primary ms-2 mr-1"
            (click)="syncToBackend()"
            >Sync to Backend</button
          >
          <button class="btn btn-primary ms-2" (click)="resetFeatureFlag()"
            >Reset</button
          >
        </div>
      </div>
    </div>

    <!-- Toggle States -->
    <ng-container *ngIf="toggles.length; else noToggles">
      <ng-container *ngIf="filteredToggles$ | async as filteredToggles">
        <!-- Display Toggles -->
        <ng-container *ngIf="filteredToggles.length; else noFilteredToggles">
          <table
            *ngIf="filteredToggles.length"
            class="override-list feature-toggle-override__list"
          >
            <thead class="feature-toggle-override__list-header">
              <tr>
                <th style="width: 0">Name</th>
                <th>Serving</th>
                <th class="text-center" style="width: 0">ON</th>
                <th class="text-center" style="width: 0">OFF</th>
                <th style="width: 0">Default</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let toggle of filteredToggles"
                class="feature-toggle-override__list-item"
                [ngClass]="{
                  'has-override': toggle.override !== null,
                }"
              >
                <td>
                  <code class="feature-toggle-override__list-item__key">{{
                    toggle.key
                  }}</code>
                </td>
                <td>
                  <code
                    class="
                      feature-toggle-override__list-item__value feature-toggle-override__list-item__value--current
                    "
                    [class]="
                      ' feature-toggle-override__list-item__value--' +
                      getCalcValue(toggle)
                    "
                    >{{ getCalcValue(toggle) }}</code
                  >
                </td>
                <td class="text-center">
                  <input
                    type="radio"
                    [name]="toggle.key"
                    [value]="true"
                    [(ngModel)]="toggle.override"
                    (change)="onRadioChange(toggle)"
                  />
                </td>
                <td class="text-center">
                  <input
                    type="radio"
                    [name]="toggle.key"
                    [value]="false"
                    [(ngModel)]="toggle.override"
                    (change)="onRadioChange(toggle)"
                  />
                </td>
                <td>
                  <input
                    type="radio"
                    [name]="toggle.key"
                    [value]="null"
                    [(ngModel)]="toggle.override"
                    (change)="onRadioChange(toggle)"
                  />&nbsp;<code
                    class="
                      feature-toggle-override__list-item__value feature-toggle-override__list-item__value--default
                    "
                    [class]="
                      'feature-toggle-override__list-item__value--' + toggle.value
                    "
                    >{{ toggle.value }}</code
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </ng-container>
      </ng-container>
    </ng-container>

    <!-- No Toggles Available -->
    <ng-template #noToggles>
      <div class="no-toggles-message"> Toggles will appear here 😊 </div>
    </ng-template>

    <!-- No Filtered Toggles Found -->
    <ng-template #noFilteredToggles>
      <div class="no-toggles-message no-toggles-message--filtered">
        No toggles match your search 🥺
      </div>
    </ng-template>
  </div>
</div>
